// List Style Plugin
export default {
    id: 'list',
    label: 'List',
    icon: 'List',
    properties: {
        listStyleImage: {
            label: 'Image',
            type: 'select',
            options: ['none'],
            default: 'none',
            toClass: (value) => value ? `list-image-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^list-image-(.+)$/);
                return match ? match[1] : null;
            }
        },
        listStylePosition: {
            label: 'Position',
            type: 'select',
            options: ['inside', 'outside'],
            default: 'outside',
            toClass: (value) => value ? `list-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^list-(inside|outside)$/);
                return match ? match[1] : null;
            }
        },
        listStyleType: {
            label: 'Type',
            type: 'select',
            options: ['none', 'disc', 'decimal'],
            default: 'disc',
            toClass: (value) => value ? `list-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^list-(none|disc|decimal)$/);
                return match ? match[1] : null;
            }
        }
    }
};
